<ml-mdm-apple-application-list-ui [applications]="groupedApplications | async"
                                  (selectedApplicationChange)="selectedApplicationChanged($event)"></ml-mdm-apple-application-list-ui>